import baseAjax from './service'
const mallRecharge = baseAjax('mall-recharge')



// 开发票
const doInvoicing = (data, header = {}) => {
    return mallRecharge('/recharge/pay/invoice', { invoice: JSON.stringify(data) }, header).then(res => {
        return res.code == 1 ? JSON.parse(res.data.result) : {}
    });
}

export {
    doInvoicing
}




// WEBPACK FOOTER //
// ./js/service/api/index.js